/**
 * Textos genéricos compartidos por los sub-paneles de MasterDocument.
 *
 * Seis conceptos —"Agregar", "Cancelar", "Guardar", "Eliminar" y los dos errores
 * genéricos— estaban escritos a mano 22 veces en español y otras tantas en inglés,
 * repartidos por los cinco catálogos. Un cambio de redacción exigía encontrar y
 * editar todas las copias, y bastaba olvidar una para que dos paneles dijeran cosas
 * distintas para la misma acción.
 *
 * ## Por qué esto y no un namespace `common.*`
 *
 * La opción evidente sería mover estos textos a claves `common.actions.add`,
 * `common.error.generic`, etc. NO se hace: las claves actuales
 * (`withholdings.actions.add`, `installments.error.generic`, …) pueden estar ya
 * registradas en el catálogo del backend, y renombrarlas dejaría a esos hosts sin
 * traducción de un día para otro. El riesgo no compensa: el problema real era la
 * duplicación del TEXTO, no el nombre de la clave.
 *
 * Así, cada catálogo conserva sus claves —contrato intacto— y toma el valor de un
 * único sitio. Si más adelante se decide unificar los namespaces, será un cambio
 * consciente y coordinado con backend, no un efecto colateral de un refactor.
 *
 * @see src/components/MasterDocument/i18n.ts - Catálogo del core
 */

/** Textos genéricos en español (idioma base del kit). */
export const TEXTO_COMUN_ES = {
  add: 'Agregar',
  cancel: 'Cancelar',
  save: 'Guardar',
  delete: 'Eliminar',
  errorForbidden: 'Sin permiso para esta operación.',
  errorGeneric: 'No se pudo completar la operación.',
} as const;

/** Los mismos conceptos en inglés. */
export const TEXTO_COMUN_EN = {
  add: 'Add',
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  errorForbidden: 'No permission for this operation.',
  errorGeneric: 'The operation could not be completed.',
} as const;
